<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px;"
        />
      </template>
    </van-nav-bar>

    <!-- ✅ 顶部提示：最多可提款（不再空） -->
    <div class="p_c">
      <span>{{$t("q14")}}：</span>
      <span class="number">{{ canWithdrawText }}</span>
    </div>

    <van-cell-group>
      <!-- 提款金额 -->
      <van-field
        v-model="withdraw_money"
        type="digit"
        :placeholder="`${$t('q61')}`"
        clearable
      >
        <template #button>
          <span class="all-btn" @click="allMoeny">全部</span>
        </template>
      </van-field>

      <!-- 资金密码 -->
      <van-field
        v-model="paypassword"
        type="password"
        :placeholder="$t('q15')"
        clearable
      />
    </van-cell-group>

    <div class="p_c">
      <span>{{$t("my.balance")}}：</span>
      <span class="number">{{ displayMoney }}{{$t("reservation.ge")}}</span>
    </div>

    <div class="p_c">{{$t('q16')}}：{{ userInfo.name || '' }}</div>

    <div class="hang_p_c">
      <input type="radio" checked />
      {{$t('q17')}} ：{{ bankInfo.bankinfo || '' }} {{ bankInfo.fhnumber || '' }}
    </div>

    <div class="sub-btn" :class="{ disabled: isSubmitting }" @click="doWithdraw">
      {{ isSubmitting ? '提交中...' : $t('q18') }}
    </div>

    <!-- ✅ 说明区：最大/最小提领走后端接口 -->
    <div class="shuoming">
      <div class="l_p q1">{{$t('q19')}}：</div>
      <div class="l_p">
        1、{{$t('q20')}}{{ roleMaxText }}
      </div>
      <div class="l_p">
        2、{{$t('q21')}}{{ roleMinText }}
      </div>
      <div class="l_p">3、{{$t('q22')}}</div>
      <div class="l_p">4、{{$t('q23')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paypassword: "",
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      bankInfo: {},

      isSubmitting: false,
    };
  },

  computed: {
    displayMoney() {
      const m = parseFloat(this.userInfo.money || 0);
      return isNaN(m) ? "0.00" : m.toFixed(2);
    },

    roleMax() {
      const r = this.withdrawRole || {};
      const v =
        r.max ??
        r.max_money ??
        r.withdraw_max ??
        r.withdrawMax ??
        r.maxAmount ??
        r.maxamount ??
        "";
      const n = parseFloat(v);
      return isNaN(n) ? "" : n;
    },

    roleMin() {
      const r = this.withdrawRole || {};
      const v =
        r.min ??
        r.min_money ??
        r.withdraw_min ??
        r.withdrawMin ??
        r.minAmount ??
        r.minamount ??
        "";
      const n = parseFloat(v);
      return isNaN(n) ? "" : n;
    },

    roleMaxText() {
      return this.roleMax === "" ? "-" : this.roleMax;
    },

    roleMinText() {
      return this.roleMin === "" ? "-" : this.roleMin;
    },

    canWithdraw() {
      const balance = parseFloat(this.userInfo.money || 0);
      if (isNaN(balance)) return 0;

      if (this.roleMax !== "") {
        return Math.max(0, Math.min(balance, this.roleMax));
      }
      return Math.max(0, balance);
    },

    canWithdrawText() {
      const n = parseFloat(this.canWithdraw || 0);
      return isNaN(n) ? "0" : n.toFixed(2);
    },
  },

  methods: {
    back() {
      return window.history.back();
    },

    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.bankInfo = (res.data && (res.data.info || res.data)) || {};
          } else if (res && res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {});
    },

    getUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.userInfo = res.data || {};
          } else if (res && res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {});
    },

    getUserWithdrawRole() {
      return this.$http({
        method: "get",
        url: "user_get_withdraw_role",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.withdrawRole = res.data || {};
          } else if (res && res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {});
    },

    allMoeny() {
      this.withdraw_money = String(this.canWithdrawText);
    },

    // ✅✅ 只有这些情况才算“真失败 / 硬性拒绝”
    // （出现这些才提示失败；其他情况即使返回失败文案，也按“已提交”提示，避免误导）
    isHardRejectMsg(msg) {
      const s = String(msg || "");
      return /密碼|密码|錯誤|错误|餘額|余额|不足|未綁定|未绑定|銀行卡|银行卡|最低|最高|限制|禁止|關閉|关闭|維護|维护|封盤|封盘|停盤|停盘|頻繁|频繁|稍後|稍后|再試|再试/i.test(
        s
      );
    },

    // ✅✅ 关键：提款是否“按已提交处理”
    // 逻辑：只要不是硬性拒绝，一律当作已提交成功（因为你的后端经常“记录已生成但接口返回失败”）
    isWithdrawAccepted(res) {
      if (!res) return false;

      // 401 仍然按未登录
      if (res.code === 401) return false;

      const msg = String(res.msg || "");
      if (this.isHardRejectMsg(msg)) return false;

      // 其他任何返回（包括 code!=200 / msg=失败 / msg为空）都按已提交处理
      return true;
    },

    doWithdraw() {
      if (this.isSubmitting) return;

      const pwd = String(this.paypassword || "").trim();
      const moneyStr = String(this.withdraw_money || "").trim();
      const money = parseFloat(moneyStr);

      if (!pwd) {
        this.$toast(this.$t("q24"));
        return;
      }

      if (!moneyStr || isNaN(money) || money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return;
      }

      if (this.roleMin !== "" && money < this.roleMin) {
        this.$toast(`最低提領金額：${this.roleMinText}`);
        return;
      }
      if (this.roleMax !== "" && money > this.roleMax) {
        this.$toast(`最高提領金額：${this.roleMaxText}`);
        return;
      }

      const balance = parseFloat(this.userInfo.money || 0);
      if (!isNaN(balance) && money > balance) {
        this.$toast("餘額不足");
        return;
      }

      this.isSubmitting = true;

      // ✅ 提交中即时反馈（防止用户觉得第一次没反应而连点）
      this.$toast("提交中...");

      const payload = {
        money: moneyStr,
        withdraw_money: moneyStr,
        paypassword: pwd,
        pay_password: pwd,
      };

      this.$http({
        method: "post",
        data: payload,
        url: "user_set_withdraw",
      })
        .then((res) => {
          if (res && res.code === 401) {
            this.$toast(res.msg);
            return;
          }

          // ✅✅ 核心修复：不是硬性拒绝，一律提示“已提交”
          if (this.isWithdrawAccepted(res)) {
            const msg = String(res && res.msg ? res.msg : "");
            const showMsg =
              msg && /成功|提交|已提交|受理|審核|审核|處理中|处理中|提款中/i.test(msg)
                ? msg
                : "提款申請已提交，請到提款記錄查看";
            this.$toast(showMsg);

            this.withdraw_money = "";
            this.paypassword = "";

            setTimeout(() => {
              this.getUserInfo();
              this.getUserWithdrawRole();
            }, 300);
          } else {
            // 真失败（硬性拒绝）才提示失败
            this.$toast((res && res.msg) || "提交失敗");
          }
        })
        .catch((err) => {
          // 500 / 网络异常：不误导
          let msg = "系統忙碌，若提款記錄已生成請以記錄為準";
          const data = err && err.response && err.response.data;
          if (data) {
            if (typeof data === "string") msg = data;
            else if (data.msg) msg = data.msg;
          }
          this.$toast(msg);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },

  mounted() {
    this.getUserBankInfo();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.p_c {
  color: #fff;
  padding: 0 30px 20px;
  font-size: 28px;
}

.p_c .number {
  color: #f3c7a2;
  font-weight: 700;
  margin-left: 6px;
}

.hang_p_c {
  padding: 0 0 20px;
  border-bottom: 1px solid #c5a081;
  margin: 0 20px;
  color: #c5a081;
  font-size: 28px;
}

.all-btn {
  color: #f3c7a2;
  font-size: 26px;
  padding: 0 10px;
}

.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  user-select: none;

  &.disabled {
    opacity: 0.7;
    pointer-events: none;
  }
}

.shuoming {
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;

  .l_p {
    font-size: 26px;
    margin-top: 16px;

    &.q1 {
      font-size: 30px;
    }
  }
}

.van-cell-group {
  background-color: transparent;
  padding: 10px 0 30px;

  &:after {
    display: none;
  }
}

.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;

  & + .van-cell {
    margin-top: 30px;
  }

  &:after {
    display: none;
  }
}

::v-deep .van-field__control {
  color: #f3c7a2;
}
</style>